import React from 'react';

// Bravo design-system metadata pill (.bravo-ds .chip). Value formatting is the
// caller's job — pass preformatted children (e.g. "name · id").
function Chip({ label, children }) {
  return (
    <span className='chip'>
      <b>{label}</b> {children}
    </span>
  );
}

export default Chip;
